import { Component } from '@angular/core';
import { previewSettings } from '../../models/settings.model';

@Component({
  selector: 'hbo-preview-external-settings',
  templateUrl: './preview-external-settings.component.html',
  styleUrls: ['./preview-external-settings.component.scss']
})
export class PreviewExternalSettingsComponent {

  previewSettings = new previewSettings();
  show = false;

  showPreview(previewSettings: previewSettings) {
    this.show = true;
    this.previewSettings = {
      app: previewSettings.app,
      logoA: previewSettings.logoA,
      fitName: previewSettings.fitName,
      logoB: previewSettings.logoB,
      m4uName: previewSettings.m4uName,
      logoC: previewSettings.logoC,
      depictName: previewSettings.depictName,
      logo1: previewSettings.logo1,
      logo2: previewSettings.logo2
    }
  }

  close() {
    this.show = false;
    this.previewSettings = {
      app: '',
      logoA: '',
      fitName: '',
      logoB: '',
      m4uName: '',
      logoC: '',
      depictName: '',
      logo1: '',
      logo2: ''
    }
  }
}
